export default __webpack_public_path__ + "static/media/plain-sticker-on.53d86716.png";